import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import WebsitesPage from "@/pages/WebsitesPage";
import ChatbotConfig from "@/pages/ChatbotConfig";
import BillingPage from "@/pages/BillingPage";
import DashboardLayout from "@/components/DashboardLayout";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ApiKeysPage from "@/pages/ApiKeysPage";
import WhiteLabelPage from "@/pages/WhiteLabelPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="text-sm font-mono uppercase tracking-[0.2em] text-[#6B7280]">
          Loading...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
      <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <AuthPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout><Dashboard /></DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/websites"
        element={
          <ProtectedRoute>
            <DashboardLayout><WebsitesPage /></DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chatbot/:websiteId"
        element={
          <ProtectedRoute>
            <DashboardLayout><ChatbotConfig /></DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <ProtectedRoute>
            <DashboardLayout><BillingPage /></DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/api-keys"
        element={
          <ProtectedRoute>
            <DashboardLayout><ApiKeysPage /></DashboardLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/white-label"
        element={
          <ProtectedRoute>
            <DashboardLayout><WhiteLabelPage /></DashboardLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
